import { connect } from 'react-redux';

import { toggleKeyboardShortcutMenu } from 'src/redux/global/actions/toggle-keyboard-shortcut-menu';
import { toggleSearchDrawer } from 'src/redux/global/actions/toggle-search-drawer';

import { NavigationKeyboardShortcuts } from '../components/navigation-keyboard-shortcuts';

const mapDispatchToProps = {
  toggleKeyboardShortcutMenu,
  toggleSearchDrawer,
};

// eslint-disable-next-line import/no-default-export
export default connect(
  undefined,
  mapDispatchToProps
)(NavigationKeyboardShortcuts);
